import React from "react";
import Nicholas from "assets/Nicholas.png";

// form & validsation
import * as yup from "yup";
import { FormError, FormLabel, FormDropDown } from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";
import Slider from "@material-ui/core/Slider";

const balance = [
  "$0 - $20,000",
  "$20,000 - $50,000",
  "$51,000 - $80,000",
  "$81,000 - $120,000",
  "$121,000 - $200,000",
  "$201,000 - $300,000",
  "$301,000 - $500,000",
  "$500,000+",
];

// schema
const schema = yup.object().shape({
  financial: yup
    .object()
    .shape({
      user_super: yup.string().required("You must provide a value"),
      partner_super: yup.string().required("You must provide a value"),
    })
    .required(),
});

export function Step11({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(schema),
  });

  function valuetext(value, name) {
    setValue(name, value);
    return `${value}°C`;
  }
  const handleData = (values) => {
    const copy_data = Object.assign({}, store.financial);
    const merger_current_values = { ...copy_data, ...values.financial };
    const mergeToStore = { ...store, financial: merger_current_values };
    onSubmit(mergeToStore);
  };

  return (
    <form id="divorce-form" onSubmit={handleSubmit(handleData)}>
      <section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="relationship.user_super"
            className={customClasses.questionText}
            error={errors?.financial?.user_super?.message}
          >
            Your superannuation balance (Approx.)
          </FormLabel>

          <article>
            <FormDropDown
              placeholder="Select Your Superannuation Balance"
              id="financial.user_super"
              type="text"
              name="financial.user_super"
              error={errors?.financial?.user_super?.message}
              register={register}
              data={balance}
              setValue={setValue}
              value={watch()?.financial?.user_super}
            />
          </article>
        </section>

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="relationship.partner_super"
            className={customClasses.questionText}
            error={errors?.financial?.partner_super?.message}
          >
            Best estimate of{" "}
            {store?.user_details?.partner_first_name
              ? store?.user_details?.partner_first_name
              : "Your Ex-Partner"}
            ’s superannuation balance
          </FormLabel>

          <article>
            <FormDropDown
              placeholder="Select Partner Superannuation Balance"
              id="financial.partner_super"
              type="text"
              name="financial.partner_super"
              error={errors?.financial?.partner_super?.message}
              register={register}
              data={balance}
              setValue={setValue}
              value={watch()?.financial?.partner_super}
            />
          </article>
        </section>
      </section>
    </form>
  );
}
